import {
  SET_FILTER,
  RESET_FILTERS,
  SET_SEARCH_TERM,
} from "../actions/filterActions";

const initialState = {
  price: { min: 0, max: 5000 },
  sizes: [],
  colors: [],
  categories: [],
  subCategory: "",
  tags: [],
  searchTerm: "",
  types: [],
  page: 1,
};

export default function filterReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FILTER:
      return {
        ...state,
        [action.payload.filterType]: action.payload.value,
      };

    case SET_SEARCH_TERM:
      return {
        ...state,
        search: action.payload,
      };

    case RESET_FILTERS:
      return initialState;

    default:
      return state;
  }
}
